import makeStateFilter from '../../../make-state-filter';

import { stateFilter as parentStateFilter } from '../customers.reducer.metadata';

const namespace = 'ordersGrid';
const stateFilter = makeStateFilter(parentStateFilter, namespace);

export { namespace, stateFilter };
